import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {APP_BASE_HREF} from '@angular/common';

import { AppComponent } from './app.component';

import { DoraLabelComponent } from './DoraWidget/dora-label/dora-label.component';
// tslint:disable-next-line:max-line-length
import { DoraDataGridSelectorTabComponent } from './DoraWidget/dora-data-grid-selector/dora-data-grid-selector-tab/dora-data-grid-selector-tab.component';
import {HttpClient, HttpClientJsonpModule, HttpClientModule} from '@angular/common/http';
import { WidgetBaseComponent } from './DoraWidget/widget-base/widget-base.component';
import {SelectModule} from 'ng2-select';
import {DoraDataGridComponent} from './DoraWidget/dora-data-grid/dora-data-grid.component';
import {MessageService} from './messages/message.service';
import {ConfigurationService} from './Configuration/configuration-service';
import {PublisherDataManagement} from './pusblisher/DataManagement/publisher-data-management';
import { DoraChartComponent } from './DoraWidget/dora-chart/dora-chart.component';
import {HighchartsChartModule} from 'highcharts-angular';
// tslint:disable-next-line:max-line-length
import { DoraChartTypeSettingLbComponent } from './DoraWidget/dora-chart-type-setting/dora-chart-type-setting-lb/dora-chart-type-setting-lb.component';
import {DoraChartTypeSettingComponent} from './DoraWidget/dora-chart-type-setting/dora-chart-type-setting.component';
import {DoraDataGridSelectorComponent} from './DoraWidget/dora-data-grid-selector/dora-data-grid-selector.component';
// tslint:disable-next-line:max-line-length
import { DoraDataGridSelectorLbComponent } from './DoraWidget/dora-data-grid-selector/dora-data-grid-selector-lb/dora-data-grid-selector-lb.component';
import {DoraRowsPreselectComponent} from './DoraWidget/dora-rows-preselect/dora-rows-preselect.component';
import { DoraRowsPreselectTabComponent } from './DoraWidget/dora-rows-preselect/dora-rows-preselect-tab/dora-rows-preselect-tab.component';
import {WidgetBaseGridComponent} from './DoraWidget/widget-base/widget-base-grid.component';
import { DoraRowsPreselectLbComponent } from './DoraWidget/dora-rows-preselect/dora-rows-preselect-lb/dora-rows-preselect-lb.component';
import {DoraColumnSelectorComponent} from './DoraWidget/dora-column-selector/dora-column-selector.component';
import {FormsModule} from '@angular/forms';
import {NgSelectModule} from '@ng-select/ng-select';
import { DoraColumnSelectorLbComponent } from './DoraWidget/dora-column-selector/dora-column-selector-lb/dora-column-selector-lb.component';
import { DoraTabComponent } from './DoraWidget/dora-tab/dora-tab.component';
import { DoraSeriesFromGridComponent } from './DoraWidget/dora-series-from-grid/dora-series-from-grid.component';
import { DoraSeriesFromRowComponent } from './DoraWidget/dora-series-from-row/dora-series-from-row.component';
import {PublisherService} from './pusblisher/publisher.service';
import { DoraCollapseExpandComponent } from './DoraWidget/dora-collapse-expand/dora-collapse-expand.component';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import { DoraGridTitleComponent } from './DoraWidget/dora-grid-title/dora-grid-title.component';
import { DoraGridNotesComponent } from './DoraWidget/dora-grid-data-notes/dora-grid-notes.component';
import { DoraRowsNotesComponent } from './DoraWidget/dora-rows-notes/dora-rows-notes.component';
import { DoraColumnPaginatorComponent } from './DoraWidget/dora-column-paginator/dora-column-paginator.component';
import {RouterModule, Routes} from '@angular/router';
import {registerLocaleData} from '@angular/common';
import localePl from '@angular/common/locales/pl';
import localePlExtra from '@angular/common/locales/extra/pl';
import localeIt from '@angular/common/locales/it';
import localeItExtra from '@angular/common/locales/extra/it';
import localeEn from '@angular/common/locales/en';
import localeEnExtra from '@angular/common/locales/extra/en';
import localeDeExtra from '@angular/common/locales/extra/de';
import localeDe from '@angular/common/locales/de';
import localeFrExtra from '@angular/common/locales/extra/fr';
import localeFr from '@angular/common/locales/fr';

import { DoraChartPrintComponent } from './DoraWidget/dora-chart-print/dora-chart-print.component';
// tslint:disable-next-line:max-line-length
import { DoraDataGridSelectorTabScrollComponent } from './DoraWidget/dora-data-grid-selector/dora-data-grid-selector-tab-scroll/dora-data-grid-selector-tab-scroll.component';
import { DoraRowComponent } from './DoraWidget/dora-row/dora-row.component';
import {ROUTER_PROVIDERS} from '@angular/router/src/router_module';
import { DoraSeriesValueComponent } from './DoraWidget/dora-series-value/dora-series-value.component';
import { DoraSeriesSelectorComponent } from './DoraWidget/dora-series-selector/dora-series-selector.component';
import {TranslationService} from './TranslationMarkers/translation.service';

registerLocaleData(localePl, 'pl', localePlExtra);
registerLocaleData(localeIt, 'it', localeItExtra);
registerLocaleData(localeEn, 'en', localeEnExtra);
registerLocaleData(localeDe, 'de', localeDeExtra);
registerLocaleData(localeFr, 'fr', localeFrExtra);

declare function extGetAppConfigurationPath(): string;

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, extGetAppConfigurationPath() + '/i18n/', '.json');
}
@NgModule({
  declarations: [
    AppComponent,
    WidgetBaseComponent,
    WidgetBaseGridComponent,
    DoraLabelComponent,
    DoraCollapseExpandComponent,
    DoraColumnSelectorComponent,
    DoraDataGridComponent,
    DoraDataGridSelectorComponent,
    DoraDataGridSelectorTabComponent,
    DoraChartComponent,
    DoraChartTypeSettingComponent,
    DoraChartTypeSettingLbComponent,
    DoraDataGridSelectorLbComponent,
    DoraColumnSelectorLbComponent,
    DoraRowsPreselectComponent,
    DoraRowsPreselectTabComponent,
    DoraRowsPreselectLbComponent,
    DoraSeriesFromGridComponent,
    DoraSeriesFromRowComponent,
    DoraTabComponent,
    DoraGridTitleComponent,
    DoraGridNotesComponent,
    DoraRowsNotesComponent,
    DoraColumnPaginatorComponent,
    DoraChartPrintComponent,
    DoraDataGridSelectorTabScrollComponent,
    DoraRowComponent,
    DoraSeriesValueComponent,
    DoraSeriesSelectorComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    HttpClientJsonpModule,
    SelectModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    // NgSelectModule,
    // FormsModule,
    HighchartsChartModule,
    RouterModule
  ],
  providers: [
    {provide: APP_BASE_HREF, useValue: '/debug/lug2/'},
    MessageService,
    ConfigurationService,
    PublisherService,
    TranslationService
    ],
  bootstrap: [AppComponent],
  entryComponents: [DoraLabelComponent,
    DoraColumnPaginatorComponent,
    DoraColumnSelectorLbComponent,
    DoraDataGridSelectorTabComponent,
    DoraDataGridSelectorTabScrollComponent,
    DoraDataGridSelectorLbComponent,
    DoraDataGridComponent,
    DoraGridNotesComponent,
    DoraGridTitleComponent,
    DoraChartComponent,
    DoraChartPrintComponent,
    DoraChartTypeSettingLbComponent,
    DoraCollapseExpandComponent,
    DoraRowsNotesComponent,
    DoraRowsPreselectTabComponent,
    DoraRowsPreselectLbComponent,
    DoraRowComponent,
    DoraSeriesFromGridComponent,
    DoraSeriesFromRowComponent,
    DoraTabComponent,
    DoraSeriesValueComponent,
    DoraSeriesSelectorComponent,
  ]
})
export class AppModule { }
